
import { mapGetters } from 'vuex';
export default {
	components:{
		registerAdvertisingPage: () => import('../../components/account/register-page.vue')
	},
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang: 'getterStoreLang'
        })
    }
}
